import { useState } from 'react'

const FOLDED_KEY = 'statement_split_pages_folded'

// The pages are for moving things between statements, not for reading them (the column on the
// right shows the page), so they start folded away. A choice either way is kept.
const loadFolded = () => window.localStorage.getItem(FOLDED_KEY) !== '0'

export const usePagesFolded = () => {
  const [folded, setFolded] = useState(loadFolded)

  const foldTo = (nowFolded: boolean) => {
    window.localStorage.setItem(FOLDED_KEY, nowFolded ? '1' : '0')
    setFolded(nowFolded)
  }

  return {
    folded,
    toggleFolded: () => foldTo(!folded),
    unfold: () => foldTo(false),
  }
}
